import Box from "./Box";
export default Box;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/table/components/box/index.js